import { useCallback, useState } from 'react';
import { fetchProductEnrichment } from '../services/productEnrichmentService';
import type { ProductEnrichment } from '../types';
import { getErrorMessage } from '../utils/errors';

export function useProductEnrichment() {
    const [enrichment, setEnrichment] = useState<ProductEnrichment | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [loaded, setLoaded] = useState(false);

    const fetchEnrichment = useCallback(async (productId: string) => {
        setLoading(true);
        setError(null);
        try {
            const data = await fetchProductEnrichment(productId);
            setEnrichment(data);
        } catch (err) {
            setError(getErrorMessage(err, 'Failed to load product enrichment data'));
            setEnrichment(null);
        } finally {
            setLoading(false);
            setLoaded(true);
        }
    }, []);

    return { enrichment, loading, error, loaded, fetchEnrichment };
}